module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-humanL-b5d9b60b68d8233e1d9e929a8537da76.png";